var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "play-btn"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 44,
    fill: "white",
    fillOpacity: 0.1,
    stroke: "currentColor",
    strokeWidth: 2,
    className: "circle"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 45.5L35 64.1195L35 26.8805L65 45.5Z",
    fill: "currentColor",
    className: "triangle"
  })));
};
export default SvgPlayButton;